import React from 'react';

import { Interactive, Text } from 'components';

import { cn } from 'domain/core';

interface SwitchProps {
	checked: boolean;
	onChange(value: boolean): void;
	label?: string;
	className?: string;
}
export const Switch = (props: SwitchProps) => {
	return (
		<Interactive onInteract={() => props.onChange(!props.checked)}>
			<div className={'flex gap-2'}>
				{props.label && <Text className='mr-2'>{props.label}</Text>}
				<div
					className={cn(
						'relative',
						'h-6 w-11 cursor-pointer rounded-full bg-gray-200',
						'after:absolute after:left-[2px] after:top-[2px] after:content-[""]',
						'after:border after:border-gray-300 after:bg-white',
						'after:h-5 after:w-5 after:rounded-full after:transition-all',
						props.checked &&
							'after:translate-x-full after:border-white after:bg-primary-600',
						props.className
					)}
				/>
			</div>
		</Interactive>
	);
};
